module.exports = __webpack_public_path__ + "img/meeting.4e53e427.png";